var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDetailsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#52C9F4;}\n\t.st1{fill:none;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -14)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,14h32v32H6V14z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDetailsActive);
export default __webpack_public_path__ + "static/media/ic_details_active.0bcfa43366cc88da85a81f8794379765.svg";
export { ForwardRef as ReactComponent };